import { gql } from 'apollo-boost'
import { ID } from '../id.type'

export interface QuoteSignatureDownloadVariables {
  id: ID
  accessKey?: string
}

export interface QuoteSignatureDownloadData {
  base64: string
}

export const QUOTE_SIGNATURE_DOWNLOAD_QUERY = gql`
  query download($id: ID!, $accessKey: String) {
    base64: getQuoteSignedPdfById(id: $id, accessKey: $accessKey)
  }
`
